import { inRange, random } from "lodash-es";

import { Attribute } from "../types";
import { userLocale } from "./LocaleUtils";

export function formatProperty(value: any, attribute: Attribute) {
  const { formatting } = attribute;
  const { noDataValue } = formatting || {
    noDataValue: { value: 0, min: 0, max: 0, label: "" },
  };

  if (!formatting) return value;
  switch (formatting.type) {
    case "number":
      if (
        noDataValue &&
        (noDataValue.value === value ||
          inRange(value, noDataValue.min || 0, noDataValue.max || 0))
      ) {
        return noDataValue.label;
      }
      return formatPropertyNumber(value, formatting.options);
    default:
      return value;
  }
}

export function formatPropertyNumber(
  value: number,
  options: Intl.NumberFormatOptions
): string {
  const { localeMatcher, unit, ...restOptions } = options;

  return `${new Intl.NumberFormat(
    userLocale(localeMatcher),
    restOptions
  ).format(value)}${unit ? ` ${unit}` : ""}`;
}

export function isArray(value: string | number) {
  const r = new RegExp(/\[.*\]/, "i");
  return r.test(`${value}`);
}

export function fromArray(value: string) {
  const result = value.match(/\[(.+)\]/);
  if (result && result[1]) return result[1].split(",");
  return [];
}

export function getRandomNumber(options?: Intl.NumberFormatOptions): number {
  const integerDigits: number[] = new Array<number>(
    options?.minimumIntegerDigits || 5
  )
    .fill(0)
    .map(() => random(0, 9));
  const fractionDigits: number[] = new Array<number>(
    random(
      options?.minimumFractionDigits || 5,
      options?.maximumFractionDigits || 15
    )
  )
    .fill(0)
    .map(() => random(0, 9));
  return parseFloat(`${integerDigits.join("")}.${fractionDigits.join("")}`);
}
